export class RumActions {
  static PROFILE_BAILLEUR_STARTED = "profile_bailleur_started";
  static PROFILE_BAILLEUR_COMPLETED = "profile_bailleur_completed";
  static PROFILE_BAILLEUR_CANCELLED = "profile_bailleur_cancelled";
  static FORM_TAB_VIEWED = "form_tab_viewed";
  static GUIDE_STARTED = "guide_started";
  static GUIDE_COMPLETED = "guide_completed";
  static GUIDE_SKIPPED = "guide_skipped";
  static ONBOARDING_SEGMENT_CHOSEN = "onboarding_segment_chosen";
  static ONBOARDING_MISSION_CTA = "onboarding_mission_cta";
  static ONBOARDING_MISSION_DISMISSED = "onboarding_mission_dismissed";
  static ONBOARDING_CHECKLIST_COLLAPSED = "onboarding_checklist_collapsed";
  static ONBOARDING_AHA_QUITTANCE_SHOWN = "onboarding_aha_quittance_shown";
}
